<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">外包公司</span>
            <el-input
              v-model="listQuery.companyName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">外包联系</span>
            <el-input
              v-model="listQuery.contactNumber"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">联系人姓名</span>
            <el-input
              v-model="listQuery.contactName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">手机号码</span>
            <el-input
              v-model="listQuery.contactPhone"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">账户类型</span>
            <el-select :filterable="true" v-model="listQuery.type" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in UserPayTypeOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">审批状态</span>
            <el-select :filterable="true" v-model="listQuery.changeStatus" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in ReviewStatusOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{isFilterCollapse ? '展开' : '收起'}}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <TableList
        ref="tableListRef"
        v-loading="listLoading"
        :dataList="list"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :isShowPagination="false"
        :canRefresh="false"
        :canChangeColumn="false"
        :highlightCurrentRow="true"
        @command-change="handleCommand"
      >
        <template v-slot:name="scope">
          <span :class="scope.row.status === 1 ? 'redStatusStyle' : scope.row.status === 2 ? 'yellowStatusStyle' : ''" class="statusStyle">
            <i class="iconfont icon-tubiao-40" v-if="scope.row.status !== 3"></i>
            <span class="status">{{ReviewStatusOption.find(k => k.id === scope.row.status) ? ReviewStatusOption.find(k => k.id === scope.row.status).mark : ''}} </span>

            <span>{{scope.row.name}} </span>
          </span>
        </template>
        <template v-slot:customerCompanyId="scope">
          <span>{{scope.row.customerCompanyName }} </span>
        </template>
        <template v-slot:operation-action="scope">
          <el-link
            v-permission="{ pkey: `${permissionName}_APPROVAL` }"
            v-if="listQuery.changeStatus !== 3"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('edit', scope.row)"
          >
            审批
          </el-link>
        </template>
      </TableList>
      <el-pagination
        class="mt-20"
        v-show="total > 0"
        :total="total"
        v-model:currentPage="listQuery.page"
        :page-size="listQuery.size"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next"
      />
    </div>
    <div v-if="dialogFormVisible">
      <div style="display:flex">
        <FormComponent
          :id="activeId"
          :initFormData="initFormData"
          :fromFieldData="originFromFieldData"
          :dialogFormVisible="dialogFormVisible"
          :api="'outsourceCompanyAccount'"
          :isShowCloseBtn="false"
          :isShowSubmitBtn="false"
          :formDisabled="true"
        />
        <FormComponent
          :id="activeId"
          :initFormData="initFormData"
          :fromFieldData="targetFromFieldData"
          :dialogFormVisible="dialogFormVisible"
          :api="'outsourceCompanyAccount'"
          :isShowCloseBtn="false"
          :isShowSubmitBtn="false"
          :formDisabled="true"
        />
      </div>
      <div class="dialog-footer mt-20">
        <el-button @click="dialogFormVisible = false" >
          {{ t("table.cancel") }}
        </el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit('approve')"
        >
          通过
        </el-button>
        <el-button
          type="danger"
          :loading="submitLoading"
          @click="handleSubmit('reject')"
        >
          拒绝
        </el-button>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { cloneDeep } from 'lodash'
import { reviewInfoById, getReviewCompanyList, reviewApprove, reviewReject } from '@/apis/OutsourceCompanyAccount'
import { getDropdown } from '@/apis/Dictionary'
import { getPageList } from '@/apis/Form'
import { getDropdownByType } from '@/apis/tool'

import { CostModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { pageVo, pageSizes } from '@/utils/index'
import { FromFieldData } from '@/views/business/outsourceCompany/accountInfo/FieldFrom'
import { TableField } from './FieldTable'
import mixin from '@/mixins/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Approvaloutsourceaccount',
  components: {
    FormComponent,
    TableList
  },
  setup() {
    const { t } = useI18n()
    const tableListRef = ref(null)
    const dataMap = reactive({
      TableName: TableName.TABLE_APPROVAL_OUTSOURCE_COMPANY_ACCOUNT,
      permissionName: permissionName.APPROVAL_OUTSOURCE_COMPANY_ACCOUNT,
      initFormData: cloneDeep(FromFieldData),
      originFromFieldData: cloneDeep(FromFieldData),
      targetFromFieldData: cloneDeep(FromFieldData),
      columnAllData: TableField,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        companyName: undefined,
        contactNumber: undefined,
        contactName: undefined,
        contactPhone: undefined,
        type: undefined,
        changeStatus: undefined,
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,

      salesManOption: [],
      ReviewStatusOption: [],
      UserPayTypeOption: [],
      submitLoading: false,
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        getReviewCompanyList(dataMap.listQuery).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.list.map((item: any) => {
            if (item.customerCompanyId) {
              getPageList(`customerCompany/dropdown?ids=${item.customerCompanyId}`).then((res: any) => {
                item.customerCompanyName = res[0].mark
              })
            }
          })
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          companyName: undefined,
          contactNumber: undefined,
          contactName: undefined,
          contactPhone: undefined,
          type: undefined,
          changeStatus: undefined,
          ...pageVo

        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.originFromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.targetFromFieldData = cloneDeep(dataMap.initFormData)

        reviewInfoById(row.id).then((res: any) => {
          const origin = res.origin
          dataMap.originFromFieldData.forEach((k: any) => {
            if (k.type === 1) {
              k.formList.forEach((field: any) => {
                field.value = origin[field.fieldKey] || field.value
              })
            }
          })
          dataMap.originFromFieldData = dataMap.originFromFieldData.filter((k: any) => k.type === 1)

          const target = res.target
          dataMap.targetFromFieldData.forEach((k: any) => {
            if (k.type === 1) {
              k.formList.forEach((field: any) => {
                field.value = target[field.fieldKey] || field.value
                switch (field.fieldKey) {
                }
              })
            }
          })
          dataMap.targetFromFieldData = dataMap.targetFromFieldData.filter((k: any) => k.type === 1)

          dataMap.originFromFieldData[0].formList.forEach((item: any) => {
            dataMap.targetFromFieldData[0].formList.forEach((k: any) => {
              if (item.fieldKey === k.fieldKey) {
                const _originValue = item.value ? item.value.toString() : item.value
                const _targetValue = k.value ? k.value.toString() : k.value
                if (_originValue !== _targetValue) {
                  item.config.colorTheme = 1
                  k.config.colorTheme = 2
                }
              }
            })
          })
          dataMap.dialogFormVisible = true
        })
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadDropdownList(url: string) {
        getDropdown(url).then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      },
      getDropdownByType() {
        getDropdownByType('ReviewStatus').then((res: any) => {
          dataMap.ReviewStatusOption = res
        })
      },

      async handleSubmit(type: string) {
        try {
          if (type === 'reject') {
            await reviewReject(dataMap.activeId)
          } else if (type === 'approve') {
            await reviewApprove(dataMap.activeId)
          }
          dataMap.dialogFormVisible = false
          dataMap.getList()
          ElMessage.success('操作成功！')
        } catch (err:any) {
          console.log(err, 'err')
        }
      },
      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 1 && column.url) {
            column.option = dataMap.UserPayTypeOption
              ? dataMap.UserPayTypeOption.map((k: any) => {
                return {
                  ...k,
                  name: k.mark
                }
              })
              : []
          }
        })
      }
    })
    const { mixinData } = mixin(dataMap)
    onMounted(async() => {
      dataMap.getList()
      await getDropdownByType('UserPayType').then((res: any) => {
        dataMap[`${'UserPayType'}Option`] = res
      })
      dataMap.getDropdownByType()
      dataMap.loadTableSelectOption()
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData), tableListRef }
  }
})
</script>
<style  lang="scss" scope>
.statusStyle{
  .status{
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color:#fff;
  }
}
.redStatusStyle{
  .icon-tubiao-40{
    color:#E74228;
  }
  .status{
    background-color:#E74228;
  }
}
.yellowStatusStyle{
  .icon-tubiao-40{
    color:#F3D03C;
  }
  .status{
    background-color:#F3D03C;
  }
}
</style>
